"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyleBase = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var colors = _interopRequireWildcard(require("../style/colors"));

var fonts = _interopRequireWildcard(require("../style/fonts"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var borderless = (0, _styledComponents.css)(["background-color:transparent;border:0;"]);
var styles = {
  primary: (0, _styledComponents.css)(["background-color:", ";border:0;color:", ";&:hover{background-color:#5140d9;}svg{fill:", ";}"], colors.primary, colors.white, colors.white),
  secondary: (0, _styledComponents.css)(["background-color:", ";color:", ";border:1px solid ", ";&:hover{background-color:rgba(77,59,216,0.2);}svg{fill:", ";}"], colors.white, colors.primary, colors.primary, colors.primary),
  danger: (0, _styledComponents.css)(["background-color:", ";color:", ";"], colors.red, colors.white),
  warning: (0, _styledComponents.css)(["background-color:", ";color:", ";"], colors.yellow, colors.white),
  success: (0, _styledComponents.css)(["background-color:", ";color:", ";"], colors.green, colors.white),
  disabled: (0, _styledComponents.css)(["background-color:", ";color:#909090;cursor:not-allowed;"], colors.borderColor),
  small: (0, _styledComponents.css)(["padding:0 22px;font-size:12px;"]),
  borderless: (0, _styledComponents.css)(["color:", ";", ";"], colors.primary, borderless),
  borderlessSubtle: (0, _styledComponents.css)(["color:", ";", ";"], colors.titleColor, borderless)
};

var StyleBase = _styledComponents["default"].button.withConfig({
  displayName: "StyleBase",
  componentId: "sc-1fl6xyc-0"
})(["outline:none;transition:background-color 0.15s ease-in;border-radius:20px;padding:", ";border:1px;font-size:14px;cursor:pointer;font-family:", ";line-height:24px;font-weight:500;", " ", ""], function (_ref) {
  var icon = _ref.icon;
  return icon ? '8px 29px 8px 14px' : '8px 32px';
}, fonts.roboto, function (_ref2) {
  var btnStyle = _ref2.btnStyle;
  return styles[btnStyle];
}, function (_ref3) {
  var size = _ref3.size;
  return styles[size];
});

exports.StyleBase = StyleBase;

var StyledIcon = _styledComponents["default"].span.withConfig({
  displayName: "StyledIcon",
  componentId: "sc-1fl6xyc-1"
})(["display:inline-flex;position:relative;top:1px;margin-right:14px;"]);

exports.StyledIcon = StyledIcon;